module.exports = __webpack_public_path__ + "img/aptus-logo.079b8606.png";